// extracted by mini-css-extract-plugin
module.exports = {"google-login":"google-login--YFdXv","googleLogin":"google-login--YFdXv"};